export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-folder-018e309a221da636dfd17e6ad9a76186.svg";